export default "__VITE_ASSET__ffcc91cd__"